import { put, takeLatest, select } from "redux-saga/effects";

import { get_categories } from "../categories/sagas";
import { get_products } from "../products/sagas";
import userSelectors from "../user/selectors";
import actions from "./actions";

import types from "./types";
// import api from './api';
// import actions from './actions';

function* app_data(action) {
  // const {username, password} = action.payload;
  const updatedAt = yield select(userSelectors.app_data_updatedAt);

  try {
    const now = new Date().getTime();
    const last = new Date(updatedAt).getTime();
    const diff = last - now;
    const diffInMinutes = diff / 1000 / 60;

    let isUpdated = false;

    if (updatedAt === 0 || diffInMinutes > 60) {
      const products = yield get_products();
      yield get_categories({ payload: { products } });
      isUpdated = true;
    }
    yield put(actions.app_data_finished({ isUpdated }));
  } catch (e) {
    yield put(actions.app_data_failed());
  }
}

export default [takeLatest(types.APP_DATA, app_data)];
